import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          {t('about.title')}
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('about.mission.title')}
          </Typography>
          <Typography paragraph>
            {t('about.mission.content')}
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('about.whatWeDo.title')}
          </Typography>
          <Typography paragraph>
            {t('about.whatWeDo.content')}
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('about.values.title')}
          </Typography>
          <Typography component="div">
            {(t('about.values.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
              <Typography key={index} paragraph>
                • {item}
              </Typography>
            ))}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default About; 